
/// Require

var ModalActionButton = require('./modal-action-button');
var BaseModal = require('./base-modal');


/// Config

var endpoint     = '/admin/ajax/vouchers/redeem';
var errorClass   = 'error';
var successClass = 'positive';
var failureClass = 'negative';


//
// Redeem Modal
//

module.exports = function RedeemModal ($host, config) {

  var base = BaseModal($host, config);


  /// Dom

  var $inputTable   = $('[name="redeem-guests"]',     $host);
  var $inputValue   = $('[name="redeem-sale-value"]', $host);
  var $outputText   = $('[data-modal-output-text]',   $host);
  var $outputTitle  = $('[data-modal-output-title]',  $host);


  /// Widgets

  var actionButton = getWidgetAtDom($('[data-action="redeem"]', $host));


  /// State

  var state = {
    name: null,
    code: null,
    table: 0,
    value: 0
  };


  /// Functions

  function populate (data) {

    log('RedeemModal::populate -', data);

    if (!isdef(data.voucher_id)) console.warn("RedeemModal::populate - expected key 'voucher_id' but didn't find it.");
    if (!isdef(data.code))       console.warn("RedeemModal::populate - expected key 'code' but didn't find it.");
    if (!isdef(data.status))     console.warn("RedeemModal::populate - expected key 'status' but didn't find it.");
    if (!isdef(data.title))      console.warn("RedeemModal::populate - key 'title' not supplied - it will be blank.");
    if (!isdef(data.text))       console.warn("RedeemModal::populate - key 'text' not supplied - it will be synthesized.");

    // Reset input and output values
    $inputTable.val(null);
    $inputValue.val(null);
    $outputText.html(data.text ? data.text : data.voucher_code + ' - ' + data.voucher_title);

    // Copy new code into state
    state.code = data.code;
    state.vid  = data.voucher_id;

    log('RedeemModal::populate - state updated -', state);

    // Put back 'expired' class signalling
    $outputTitle.toggleClass(errorClass, data.status === 'expired');

    // Clear visual state
    $host.removeClass(successClass).removeClass(failureClass);
    actionButton.setMode(ModalActionButton.ACTION_NEUTRAL);

    // Wait slightly for modal to be visible, then focus first input
    delay(0.2, $inputValue.focus.bind($inputValue));

  }

  function checkCompleteness () {
    state.value = $inputValue.val();
    state.table = $inputTable.val();
    var valueOk = !!state.value && state.value > 0;
    var tableOk = !!state.table && state.table > 0;
    actionButton.setMode((tableOk && valueOk) ? ModalActionButton.ACTION_READY : ModalActionButton.ACTION_NEUTRAL);
  }


  /// Listeners

  $inputValue.on('change keyup', checkCompleteness);
  $inputTable.on('change keyup', checkCompleteness);

  actionButton.onCancelClick(base.conceal);

  actionButton.onReadyClick(function () {
    actionButton.submit({
      vid: state.vid,
      code: state.code,
      sale_value: state.value,
      num_customers: state.table
    });
  });

  actionButton.onSuccess(function () {
    $host.addClass(successClass);
    delay(1, base.conceal);
    delay(1.1, reloadPage);
  });


  /// Interface

  return {
    invoke: function (data) {
      base.reveal();
      populate(data);
    }
  };

};

